/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Pdfsam_PlatformsInputs */

const en_pc_alt_t_pdfsam_platforms = /** @type {(inputs: Pc_Alt_T_Pdfsam_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows, macOS, Linux`)
};

const zh_pc_alt_t_pdfsam_platforms = /** @type {(inputs: Pc_Alt_T_Pdfsam_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows、macOS、Linux`)
};

/**
* | output |
* | --- |
* | "Windows, macOS, Linux" |
*
* @param {Pc_Alt_T_Pdfsam_PlatformsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_pdfsam_platforms = /** @type {((inputs?: Pc_Alt_T_Pdfsam_PlatformsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Pdfsam_PlatformsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_pdfsam_platforms(inputs)
	return zh_pc_alt_t_pdfsam_platforms(inputs)
});
export { pc_alt_t_pdfsam_platforms as "pc.alt.t.pdfsam.platforms" }